import { IFormItem } from '@components/Form/FormItem/FormItem';
import { RoleResponse } from '@/api/roles/types';
import { enumToOptions } from '@/utils/utils';
import {
  OrganizationLevelType,
  OrganizationStatusLabel,
} from '@/shared/organizations/enums';

export const orgCardSchema = (
  allRoles: RoleResponse[],
  parentOrg: any[],
  level: string,
): IFormItem[] => [
  {
    label: 'Областной уровень',
    key: 'regionParentId',
    type: 'select',
    payload: {
      options: parentOrg,
      fieldNames: {
        label: 'name',
        value: 'id',
      },
    },
    disabled: true,
  },
  {
    label: 'Районный уровень',
    key: 'districtParentId',
    type: 'select',
    payload: {
      options: parentOrg,
      fieldNames: {
        label: 'name',
        value: 'id',
      },
    },
    hidden: level === OrganizationLevelType.DISTRICT,
    disabled: true,
  },
  {
    label: 'Полное название',
    key: 'name',
    type: 'text',
    disabled: true,
  },
  {
    label: 'Краткое название',
    key: 'shortName',
    type: 'text',
    disabled: true,
  },
  {
    label: 'Роли в организации',
    key: 'roleNames',
    type: 'select',
    payload: {
      options: allRoles,
      fieldNames: {
        label: 'description',
        value: 'name',
      },
    },
    disabled: true,
  },
  {
    label: 'Статус',
    key: 'status',
    type: 'select',
    payload: {
      options: enumToOptions(OrganizationStatusLabel),
    },
    disabled: true,
  },
];
